import { ListColumn, ListColumnAlignment } from '@/interfaces'
import { computed } from 'vue'
import i18n from '@/i18n'

const domainsCols = computed<ListColumn[]>(() => {
  return [
    {
      name: 'domain',
      title: 'publisher-domain-address',
      width: 19,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 1,
      priority: 1,
      expand: true
    },
    {
      name: 'system_status',
      title: 'settings-domain-status',
      width: 18,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 2,
      priority: 2
    },
    {
      name: 'create_date',
      title: 'create-date',
      width: 17,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 4,
      priority: 4
    },
    {
      name: 'settings-status',
      title: 'inventory-my-domains-col-status-ads-txt',
      width: 18,
      alignment: ListColumnAlignment.Center,
      sortable: false,
      position: 3,
      priority: 3,
      tooltip: i18n.global.t('inventory-my-domains-col-status-ads-txt-info')
    },
    {
      name: 'actions',
      title: ``,
      width: 15,
      alignment: ListColumnAlignment.Center,
      sortable: false,
      position: 5,
      priority: 0,
      minWidthInPx: '250px'
    }
  ]
})

export default domainsCols
